import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Search: "",
};
const Reducer = createSlice({
  name: "Local",
  initialState,
  reducers: {
    SetLocalFilter(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    ResetLocalFilter(state) {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export default Reducer.reducer;
export const {
  SetLocalFilter,
  ResetLocalFilter
} = Reducer.actions;
